export const environment = {
  isProduction: false,
  apiUrl: 'https://apihml.crmstack.com.br/api'
};
